var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCampaignsWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon save points white") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-save-points-white",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.2567831,7 C27.2567831,7 28.5231009,11.5709291 28.5231009,15.2794187 C28.5231009,18.8326693 26.2129265,21.713217 22.6877714,21.713217 C19.1455039,21.713217 16.475969,18.8326693 16.475969,15.2794187 L16.5273063,14.6584623 C13.0706008,18.7981717 11,24.1625451 11,29.9926358 C11,37.6166005 17.1262404,43.791667 24.6899226,43.791667 C32.2536048,43.791667 38.3798452,37.6166005 38.3798452,29.9926358 C38.3798452,20.6955385 33.9477328,12.398871 27.2567831,7 Z M24.1936629,38.6170303 C21.1476551,38.6170303 18.6834691,36.2021998 18.6834691,33.2009105 C18.6834691,30.4066067 20.4802714,28.4402448 23.4920544,27.8192884 C26.5209498,27.198332 29.6525195,25.7321849 31.3979847,23.3691008 C32.0653684,25.5941946 32.4076165,27.9400299 32.4076165,30.3376116 C32.4076165,34.9085406 28.7284498,38.6170303 24.1936629,38.6170303 Z",
    id: "Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampaignsWhite);
export default __webpack_public_path__ + "static/media/campaigns-white.1abe1d9bda060a21635bb88a531fe85d.svg";
export { ForwardRef as ReactComponent };